<!--eslint-disable vue/no-v-html-->
<template>
  <iColumn
    v-if="sanitizedCustomHtml || editMode"
    :width="myWidth"
    :height="myHeight"
    :min-width="getOptionValue(MinWidth)"
    :max-width="getOptionValue(MaxWidth)"
    :min-height="getOptionValue(MinHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :style-overrides="{
      paddingTop: myPadding().top,
      paddingRight: myPadding().right,
      paddingBottom: myPadding().bottom,
      paddingLeft: myPadding().left,
      marginTop: myMargins().top,
      marginRight: myMargins().right,
      marginBottom: myMargins().bottom,
      marginLeft: myMargins().left,
    }"
  >
    <div
      class="custom-html-element"
      v-html="sanitizedCustomHtml || '<p>Custom HTML</p>'"
    />
  </iColumn>
</template>

<script>
import DOMPurify from "dompurify";
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import CustomHtml from "%/dynamic-components/render-engine/options/text-options/custom-html";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import Padding, { PADDING_DEFAULT_EMPTY_VALUE } from "%/dynamic-components/render-engine/options/spacing-options/padding";
import Margins, { MARGIN_DEFAULT_EMPTY_VALUE } from "%/dynamic-components/render-engine/options/spacing-options/margins";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";

export default {
  name: "CustomHtmlElement",
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "Custom HTML",
    displayIcon: "code",
    elementGroup: "general",
    elementType: "element",
  },
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
      "default.layout-height": "hug",
    }),
    SpacingOptions,
  ],
  options: [
    CustomHtml,
  ],
  data() {
    return {
      MinWidth,
      MaxWidth,
      MinHeight,
      MaxHeight,
    };
  },
  computed: {
    sanitizedCustomHtml() {
      const customHtml = this.getOptionValue(CustomHtml);
      return DOMPurify.sanitize(customHtml || "");
    },
    myWidth() {
      return this.getOptionValue(LayoutWidth);
    },
    myHeight() {
      return this.getOptionValue(LayoutHeight);
    },
  },
  methods: {
    myPadding(state = BaseOption.$states.DEFAULT) {
      let paddingValues = this.getOptionValue(Padding, state, null);
      const paddingKeys = Object.keys(paddingValues);
      paddingKeys.forEach(paddingKey => {
        const paddingVal = paddingValues[paddingKey];
        if (paddingVal === null) {
          paddingValues[paddingKey] = PADDING_DEFAULT_EMPTY_VALUE;
        }
      });
      return paddingValues;
    },
    myMargins(state = BaseOption.$states.DEFAULT) {
      let marginValues = this.getOptionValue(Margins, state, null);
      const marginKeys = Object.keys(marginValues);
      marginKeys.forEach(marginKey => {
        const marginVal = marginValues[marginKey];
        if (marginVal === null) {
          marginValues[marginKey] = MARGIN_DEFAULT_EMPTY_VALUE;
        }
      });
      return marginValues;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-html-element {
  width: 100%;
  height: 100%;
}
</style>
